import React from 'react';
import { Container, Typography, Box } from '@mui/material';

const Terms = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Typography variant="h4" gutterBottom>
        Terms of Service
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: {new Date().toLocaleDateString()}
      </Typography>

      <Box sx={{ mt: 4 }}>
        <Typography variant="h6" gutterBottom>
          1. Acceptance of Terms
        </Typography>
        <Typography paragraph>
          By accessing or using this application, you agree to be bound by these Terms of Service. If you do not agree, do not use the application.
        </Typography>

        <Typography variant="h6" gutterBottom>
          2. Use of the Service
        </Typography>
        <Typography paragraph>
          You agree to use the service only for lawful purposes and in accordance with these terms. You are responsible for your account and the activity that occurs under your account.
        </Typography>

        <Typography variant="h6" gutterBottom>
          3. Accounts and Security
        </Typography>
        <Typography paragraph>
          You must safeguard your login credentials and notify us immediately of any unauthorized use of your account. We are not liable for any loss or damage arising from your failure to comply.
        </Typography>

        <Typography variant="h6" gutterBottom>
          4. Intellectual Property
        </Typography>
        <Typography paragraph>
          All content, features, and functionality are the exclusive property of the application owners or its licensors and are protected by applicable laws.
        </Typography>

        <Typography variant="h6" gutterBottom>
          5. Third-Party Services
        </Typography>
        <Typography paragraph>
          The service may integrate with third-party platforms. We are not responsible for third-party content, policies, or practices.
        </Typography>

        <Typography variant="h6" gutterBottom>
          6. Termination
        </Typography>
        <Typography paragraph>
          We may suspend or terminate access to the service immediately, without prior notice, for conduct that violates these terms or is otherwise harmful.
        </Typography>

        <Typography variant="h6" gutterBottom>
          7. Disclaimer of Warranties
        </Typography>
        <Typography paragraph>
          The service is provided on an "AS IS" and "AS AVAILABLE" basis without warranties of any kind, express or implied.
        </Typography>

        <Typography variant="h6" gutterBottom>
          8. Limitation of Liability
        </Typography>
        <Typography paragraph>
          To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, consequential, or punitive damages.
        </Typography>

        <Typography variant="h6" gutterBottom>
          9. Changes to Terms
        </Typography>
        <Typography paragraph>
          We may update these terms from time to time. Continued use of the service after changes constitutes acceptance of the new terms.
        </Typography>

        <Typography variant="h6" gutterBottom>
          10. Contact Us
        </Typography>
        <Typography paragraph>
          If you have questions about these Terms, contact us via the support channels provided in the app.
        </Typography>
      </Box>
    </Container>
  );
};

export default Terms;
